module.exports = __webpack_public_path__ + "vue/img/new_facility_2.1b19fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/new_facility_2.png
// module id = wRR5
// module chunks = 1